module.exports = __webpack_public_path__ + "img/eventtype-alarm.a1dd0f65.svg";